/* @flow */
import { actionsPreprocessor } from '../../utils/redux';

const actionNames = ['CHANGE_LAYOUT_COLLAPSED'];

const { actions, actionTypes } = actionsPreprocessor('sidebar', actionNames);

export default actions;
export { actionTypes };
